export default function rangeCalendar(container, fromInput, toInput, months) {
	// --- anchors we compare to "today" ---
	const today = new Date(); today.setHours(0, 0, 0, 0); // midnight today
	const minCursor = new Date(today.getFullYear(), today.getMonth(), 1); // first of this month

	let cursor = new Date(); cursor.setDate(1); // current month

	const state = {
		start: fromInput.value ? new Date(fromInput.value + 'T00:00:00') : null,
		end: toInput.value ? new Date(toInput.value + 'T00:00:00') : null
	};

	const ymd = (d) => {
		if (!d) {
			return '';
		}
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${ year }-${ month }-${ day }`;
	};
	const sameDay = (a, b) =>
		a && b &&
		a.getFullYear() === b.getFullYear() &&
		a.getMonth() === b.getMonth() &&
		a.getDate() === b.getDate();

	const inRange = (d) => state.start && state.end && d >= state.start && d <= state.end;

	const DOW_LABELS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
	const mondayIndex = (jsDow) => (jsDow + 6) % 7;

	const swallow = (e) => {
		e.preventDefault(); e.stopPropagation();
	};

	function monthNode(firstOfMonth) {
		const y = firstOfMonth.getFullYear();
		const m = firstOfMonth.getMonth();
		const titleTxt = firstOfMonth.toLocaleString(undefined, { month: 'long', year: 'numeric' });

		const wrap = document.createElement('div'); wrap.className = 'cal';

		const monthTitle = document.createElement('div');
		monthTitle.className = 'farlo-ui-ticket-calendar__header-month-year';
		monthTitle.textContent = titleTxt;
		wrap.appendChild(monthTitle);

		const weekdays = document.createElement('div');
		weekdays.className = 'farlo-ui-ticket-calendar__week-days';
		weekdays.innerHTML = DOW_LABELS.map((d) => `<div class="farlo-ui-ticket-calendar__week-day">${ d }</div>`).join('');
		wrap.appendChild(weekdays);

		const daysWrap = document.createElement('div'); daysWrap.className = 'farlo-ui-ticket-calendar__days';

		const jsDowFirst = new Date(y, m, 1).getDay();
		const startDow = mondayIndex(jsDowFirst);
		const daysIn = new Date(y, m + 1, 0).getDate();
		let day = 1 - startDow;

		for (let r = 0; r < 6; r ++) {
			const week = document.createElement('div'); week.className = 'farlo-ui-ticket-calendar__week';
			for (let c = 0; c < 7; c ++, day ++) {
				const cell = document.createElement('div'); cell.className = 'farlo-ui-ticket-calendar__day';

				if (day < 1 || day > daysIn) {
					cell.classList.add('farlo-ui-ticket-calendar__day--outside');
				} else {
					const d = new Date(y, m, day); d.setHours(0, 0, 0, 0);
					const isPast = d < today;

					const num = document.createElement('div');
					num.className = 'farlo-ui-ticket-calendar__day-number';
					num.textContent = String(day);
					cell.appendChild(num);

					cell.classList.toggle('is-edge', sameDay(d, state.start) || sameDay(d, state.end));
					cell.classList.toggle('is-in', inRange(d) && !sameDay(d, state.start) && !sameDay(d, state.end));

					if (isPast) {
						// mark disabled past dates
						cell.classList.add('is-disabled', 'farlo-ui-ticket-calendar__day--disabled');
						cell.setAttribute('aria-disabled', 'true');
					} else {
						// clickable future/today cells
						cell.tabIndex = 0;
						const onPick = (ev) => {
							swallow(ev);
							if (!state.start || (state.start && state.end)) {
								state.start = d; state.end = null;
							} else if (state.start && !state.end) {
								if (d < state.start) {
									state.end = state.start; state.start = d;
								} else {
									state.end = d;
								}
							}
							fromInput.value = ymd(state.start);
							toInput.value = ymd(state.end);
							try {
								const evOpts = { bubbles: true };
								fromInput.dispatchEvent(new Event('input', evOpts));
								fromInput.dispatchEvent(new Event('change', evOpts));
								toInput.dispatchEvent(new Event('input', evOpts));
								toInput.dispatchEvent(new Event('change', evOpts));
								container.dispatchEvent(new CustomEvent('date-selected', {
									bubbles: true,
									detail: { start: ymd(state.start), end: ymd(state.end) }
								}));
							} catch {}
							requestAnimationFrame(paint);
						};
						cell.addEventListener('click', onPick);
						cell.addEventListener('keydown', (e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								onPick(e);
							}
						});
					}
				}
				week.appendChild(cell);
			}
			daysWrap.appendChild(week);
		}

		wrap.appendChild(daysWrap);
		return wrap;
	}

	function paint() {
		container.innerHTML = '';

		const header = document.createElement('div');
		header.className = 'farlo-ui-ticket-calendar__header';

		const prev = document.createElement('button'); prev.type = 'button';
		prev.className = 'farlo-ui-ticket-calendar__button farlo-ui-ticket-calendar__button--prev';
		prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M7.83108 1.32864L1.94531 7.21441L7.83108 13.1002" stroke="white" stroke-width="1.96192" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.83108 1.32864L1.94531 7.21441L7.83108 13.1002" stroke="black" stroke-width="1.96192" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		const spacer = document.createElement('div'); spacer.style.gridColumn = '2 / 3';

		const next = document.createElement('button'); next.type = 'button';
		next.className = 'farlo-ui-ticket-calendar__button farlo-ui-ticket-calendar__button--next';
		next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M1.2783 1.32864L7.16406 7.21441L1.2783 13.1002" stroke="white" stroke-width="1.96192" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.2783 1.32864L7.16406 7.21441L1.2783 13.1002" stroke="black" stroke-width="1.96192" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		header.append(prev, spacer, next);
		container.appendChild(header);

		// block navigating earlier than current month
		const prevWouldBe = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
		const prevDisabled = prevWouldBe < minCursor;
		if (prevDisabled) {
			prev.disabled = true;
			prev.setAttribute('aria-disabled', 'true');
			prev.classList.add('is-disabled');
		}

		prev.addEventListener('click', (ev) => {
			swallow(ev);
			if (prevDisabled) {
				return;
			}
			cursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
			paint();
		});
		next.addEventListener('click', (ev) => {
			swallow(ev);
			cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
			paint();
		});

		const grid = document.createElement('div'); grid.className = 'range-calendar';
		for (let i = 0; i < months; i ++) {
			grid.appendChild(monthNode(new Date(cursor.getFullYear(), cursor.getMonth() + i, 1)));
		}
		container.appendChild(grid);
	}

	// keep clicks inside from closing parent popovers
	container.addEventListener('mousedown', swallow);
	container.addEventListener('click', swallow);

	paint();
}
